import React, { Fragment } from "react"

import { DialogContent, DialogTitle, Popover as MuiPopover, Paper } from "@mui/material"
import { makeStyles } from "@mui/styles"

// TODO: Refactor the component. Replace "makeStyles" with "styled"
export const useStyles = makeStyles(({ typography }) => ({
  dialogTitle: {
    color: "#554854",
    fontSize: "20px !important",
    fontWeight: "700 !important",
    lineHeight: "28px !important",
    marginBottom: "16px !important",
    overflow: "hidden",
    padding: "0 !important",
  },

  contentContainer: {
    fontSize: typography.pxToRem(14),
    fontWeight: "bold",
    color: "#554854",
    padding: "0 !important",
    "&[class*='MuiDialogContent']": {
      backgroundColor: "transparent",
    },
  },

  paper: {
    height: "auto",
    maxWidth: "730px",
    padding: "32px",
  },
}))

export const Popover = ({
  className,
  anchor,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "left",
  },
  content,
  contentTitle,
  onClose,
  open,
  title,
  transformOrigin = {
    vertical: "top",
    horizontal: "center",
  },
}) => {
  const { contentContainer, dialogTitle, paper } = useStyles()

  return (
    <MuiPopover
      disableEnforceFocus
      classes={{ paper: className }}
      open={open}
      anchorEl={anchor}
      elevation={2}
      onClose={(event) => {
        event.stopPropagation()
        onClose()
      }}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}>
      <Paper classes={{ root: paper }}>
        <DialogTitle classes={{ root: dialogTitle }}>{title}</DialogTitle>

        <DialogContent classes={{ root: contentContainer }}>
          <Fragment>
            {contentTitle && <div style={{ paddingBottom: "20px" }}>{contentTitle}</div>}
            {content}
          </Fragment>
        </DialogContent>
      </Paper>
    </MuiPopover>
  )
}
